import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import ProfileSelectionComponent from './profile-selection.component';

let ProfileSelectionModule = angular
  .module('ProfileSelection', [
    uiRouter
  ])
  .component('profileSelection', ProfileSelectionComponent)
  .config(($stateProvider) => {
    "ngInject";

    $stateProvider.state('profileSelection', {
      params: {
        profiles: null
      },
      data: {
        authRequired: true,
        paymentExempt: true,
        permsRequired: []
      },
      views: {
        'menu': "",
        'content': {
          component: 'profileSelection',
          bindings: {
            profiles: 'profiles'
          }
        }
      },
      resolve: {
        profiles: ($transition$, $q, LoginService) => {
          var profilesFromParams = $transition$.params().profiles;
          if (profilesFromParams) {
            return $q((resolve, reject) => {
              resolve(profilesFromParams || []);
            });
          }

          return LoginService.getUserProfiles().toPromise();
        },
        invitations: ($transition$, $q) => {
          // NOTE: A call to ContentService.getUserInvitations() was being made, deacttivated
          // in exchange of a parameter (for more info see commit 7f5215d1b).
          var invitationsFromParams = $transition$.params().invitations || [];
          return $q((resolve, reject) => {
            resolve(invitationsFromParams);
          });
        }
      }
    });
  })
  .name;

export default ProfileSelectionModule;



// WEBPACK FOOTER //
// ./src/app/pages/profile-selection/profile-selection.module.js